import React from 'react';
import { KeyRound } from 'lucide-react';

import { CabinetsRolesCard } from '../CabinetsRolesCard';
import { PlateformeBriquesDelegablesCard } from '../PlateformeBriquesDelegablesCard';

interface PlateformeDroitsTabProps {
  plateformeId: string;
}

/**
 * Onglet « Rôles » de la fiche plateforme (admin) : les droits des courtiers
 * dans cette plateforme et le plafond délégable de sa gouvernance.
 */
export const PlateformeDroitsTab: React.FC<PlateformeDroitsTabProps> = ({ plateformeId }) => (
  <div className="space-y-5">
    <div>
      {/* Même gabarit de titre que les onglets Intermédiaires et Habilitations
          tunnels (icône primaire + text-3xl), icône alignée sur le menu latéral. */}
      <h2 className="text-3xl font-semibold text-zinc-800 flex items-center gap-3">
        <KeyRound className="text-primary w-7 h-7" />
        Rôles des acteurs
      </h2>
      <p className="mt-2 text-sm text-gray-500">
        Chaque acteur de la plateforme (courtier, MIA, professionnel de l'immobilier…) y exerce
        les rôles de son compte — sauf si des droits propres à cette plateforme lui ont été posés.
      </p>
    </div>

    <div className="flex flex-col gap-6 xl:flex-row-reverse xl:items-start">
    {/* Compacte, à droite du tableau (au-dessus en écran étroit). */}
    <div className="w-full xl:w-80 xl:flex-shrink-0">
      <PlateformeBriquesDelegablesCard plateformeId={plateformeId} />
    </div>
      <div className="min-w-0 flex-1">
        <CabinetsRolesCard plateformeId={plateformeId} />
      </div>
    </div>
  </div>
);
